import { Component, ChangeDetectionStrategy } from '@angular/core';
import {ToastService} from '@services/toast.service';
import {AsyncPipe, NgClass} from '@angular/common';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
	selector: 'peps-toast-container',
	imports: [
		NgClass,
		AsyncPipe
	],
	templateUrl: './toast-container.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	animations: [
		trigger('toastAnimation', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(20px)' }),
				animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
			])
		])
	]
})
export class ToastContainerComponent {
	constructor(
		public toastService: ToastService
	) {}

}
